import { ShipModel } from './ship-model';

export class ShipOverviewModel {
  ship: ShipModel;
  country: any;
  shipType: any;
  shipStatus: any;
  contactList: any;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/ship-overview-model.ts